function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequirementLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2,20v3a1,1,0,0,0,.27.67L5.33,20Z",
    style: {
      fill: "#3b7ff5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.17,13H10a1,1,0,0,1,0-2h2.83L14.5,9H10a1,1,0,0,1,0-2h6.17l1.66-2H10a1,1,0,0,1,0-2h8a1,1,0,0,1,.94.68L21.73.33A1,1,0,0,0,21,0H3A1,1,0,0,0,2,1V19H6.17ZM6,3A1,1,0,1,1,5,4,1,1,0,0,1,6,3ZM6,7A1,1,0,1,1,5,8,1,1,0,0,1,6,7ZM5,12a1,1,0,1,1,1,1A1,1,0,0,1,5,12Z",
    style: {
      fill: "#3b7ff5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42,20.14,9.25,20H5.33L2.27,23.67A1,1,0,0,0,3,24H21a1,1,0,0,0,1-1V20H14.75A4.27,4.27,0,0,1,9.42,20.14Z",
    style: {
      fill: "#4d94ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,4a1,1,0,0,1-1,1h-.17L16.17,7H18a1,1,0,0,1,0,2H14.5l-1.67,2H18a1,1,0,0,1,0,2H11.17l-5,6h4.08a2.33,2.33,0,0,0,3.28.22l.22-.22H22V1a1,1,0,0,0-.27-.67L18.94,3.68A1.13,1.13,0,0,1,19,4Z",
    style: {
      fill: "#4d94ff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequirementLight);
export default __webpack_public_path__ + "static/media/requirement_light.1c335bdd94f9b22b3360de3704d6ec5d.svg";
export { ForwardRef as ReactComponent };